import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createVNode as _createVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = ["aria-label"]
const _hoisted_2 = { class: "bg-white w-full text-gray-600 divide-y" }
const _hoisted_3 = { class: "text-black" }
const _hoisted_4 = { class: "p-6 text-left font-normal" }
const _hoisted_5 = { class: "p-6 text-left font-normal" }
const _hoisted_6 = { class: "p-6 text-green-600" }
const _hoisted_7 = { class: "p-6" }

import { PropType } from "vue";
import Button from "@/components/common/Button.vue";
import { LinkIcon } from "@heroicons/vue/outline";
import { useRouter } from "vue-router";
import { t } from "@/i18n";

interface ILinkedDocument {
  id: string;
  name: string;
}

export default /*#__PURE__*/_defineComponent({
  props: {
  linkedDocuments: {
    type: Array as PropType<ILinkedDocument[]>,
    required: true,
  },
},
  setup(__props) {

const props = __props


const router = useRouter();

const clickHandler = async (documentId: string) => {
  await router.push({ name: "DocumentDetails", params: { id: documentId } });
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "table-scroll",
    style: {"--table-min-width":"480px"},
    tabindex: "0",
    role: "region",
    "aria-label": _ctx.$t('common.scrollableTable')
  }, [
    _createElementVNode("table", _hoisted_2, [
      _createElementVNode("tr", _hoisted_3, [
        _createElementVNode("th", _hoisted_4, _toDisplayString(_unref(t)("linkedDocuments.name")), 1),
        _createElementVNode("th", _hoisted_5, _toDisplayString(_unref(t)("linkedDocuments.action")), 1)
      ]),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.linkedDocuments, (linkedDocument, index) => {
        return (_openBlock(), _createElementBlock("tr", { key: index }, [
          _createElementVNode("td", _hoisted_6, _toDisplayString(linkedDocument.name), 1),
          _createElementVNode("td", _hoisted_7, [
            _createVNode(Button, {
              onClick: ($event: any) => (clickHandler(linkedDocument.id))
            }, {
              default: _withCtx(() => [
                _createVNode(_unref(LinkIcon), { style: {"width":"16px"} })
              ]),
              _: 2
            }, 1032, ["onClick"])
          ])
        ]))
      }), 128))
    ])
  ], 8, _hoisted_1))
}
}

})